import { withTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import ReactJoyride from "react-joyride";
import { useCurrentUser } from "@hooks/use-current-user";
import { useReloadUser } from "@hooks/use-modify-user";
import TourGuideTooltip from "./TourGuideTooltip";
import { putUserTagTourGuide } from "@utils/call-api/users-call";
import isServer from "@utils/is-server";

function TourGuide({ tourGuideAllowed, t }) {
  const user = useCurrentUser();
  const reloadUser = useReloadUser();

  const tourGuideToShow = user?.tour_guide_to_show;
  const userPlan = user?.subscription?.plan_price?.plan;

  const [run, setRun] = useState(false);

  const steps = [
    {
      target: ".tour-guide-target-step-1",
      title: t("common:tour_guide.step_1.title"),
      content: t("common:tour_guide.step_1.content"),
      imageSrc: "handbagHappyRetro",
      disableBeacon: true,
      buttonText: t("common:tour_guide.next"),
      spotlightPadding: 8,
      offSet: 0,
    },
    {
      target: ".tour-guide-target-step-2",
      title: t("common:tour_guide.step_2.title"),
      content: t("common:tour_guide.step_2.content"),
      imageSrc: "boxAutumn",
      disableBeacon: true,
      buttonText: t("common:tour_guide.next"),
      spotlightPadding: 0,
    },
    {
      target: ".tour-guide-target-step-3",
      title: t("common:tour_guide.step_3.title"),
      content: t("common:tour_guide.step_3.content"),
      imageSrc: "closetLight",
      disableBeacon: true,
      buttonText: t("common:tour_guide.next"),
      spotlightPadding: 0,
    },
    {
      target: "body",
      title: t("common:tour_guide.step_4.title"),
      content: t("common:tour_guide.step_4.content", {
        count: userPlan?.clothes + userPlan?.accessories,
      }),
      imageSrc: "partyNeon",
      disableBeacon: true,
      placement: "center",
      buttonText: t("common:tour_guide.end"),
      spotlightPadding: 8,
    },
  ];

  async function finishTour() {
    document.body.classList.remove("stop-scrolling");

    try {
      await putUserTagTourGuide();

      await reloadUser();
    } catch {
      await reloadUser();
    } finally {
      setRun(false);
    }
  }

  function handleJoyrideCallback(data) {
    if (!data) return;

    const { status, action } = data;

    if (status === "finished" || action === "close") {
      finishTour();
    }
  }

  useEffect(() => {
    function startTour() {
      if (!tourGuideAllowed || !tourGuideToShow || isServer()) return;

      document.body.classList.add("stop-scrolling");
      setRun(true);
    }

    startTour();
  }, [tourGuideAllowed, tourGuideToShow]);

  if (!user) return null;

  return (
    <ReactJoyride
      key="joyride"
      run={run}
      callback={handleJoyrideCallback}
      steps={steps}
      disableOverlayClose={true}
      continuous={true}
      tooltipComponent={(props) => (
        <TourGuideTooltip
          steps={steps}
          {...props}
        />
      )}
      floaterProps={{
        disableAnimation: true,
      }}
      styles={{
        spotlight: {
          borderRadius: 0,
        },
        options: {
          zIndex: 2000,
        },
      }}
    />
  );
}

export default withTranslation("common")(TourGuide);
